export const enum TableCheckStatus {
	check = 'check',
	uncheck = 'uncheck',
	minus = 'minus',
}

export function createFlagManager<T = boolean>() {
	return {
		state: window.Vue.observable({
			map: {} as { [k: string]: T }
		}),
		get(key: string) {
			return this.state.map[key]
		},
		set(key: string, val: T) {
			if (this.state.map.hasOwnProperty(key)) {
				this.state.map[key] = val
			} else {
				window.Vue.prototype.$set(this.state.map, key, val)
			}
		},
		getActiveKeys(): string[] {
			const keys: string[] = []
			for (let key in this.state.map) {
				if (this.state.map.hasOwnProperty(key) && !!this.state.map[key]) {
					keys.push(key)
				}
			}
			return keys
		}
	}
}